<template>
  <div @click="openHyperlink">
    <data-input
      class="data-input-hyperlink"
      :class="{ 'data-input-hyperlink-enabled': clickable }"
      v-model="computedValue"
      v-bind="{ isEditingOn, ...$attrs, ...staticProps }"
    >
      <template #prepend-inner>
        <v-icon>mdi-web</v-icon>
      </template>
    </data-input>
  </div>
</template>
<script>
export default {
  name: 'DataInputHyperlink',
  components: { DataInput: () => import('@/components/DataInput') },
  props: {
    value: {
      required: true,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    clickable() {
      return !this.isEditingOn && this.computedValue;
    },
    staticProps() {
      return {
        prependInnerIcon: 'mdi-web',
        dataType: { name: 'text' },
      };
    },
  },
  methods: {
    openHyperlink() {
      if (!this.clickable) {
        return;
      }
      if (!this.computedValue.match(/^https?:\/\//i)) {
        window.open(`http://${this.computedValue}`, '_blank');
        return;
      }
      window.open(this.computedValue, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.data-input-hyperlink {
  ::v-deep {
    .v-text-field__slot {
      padding-left: 5px;
    }
  }
}
.data-input-hyperlink-enabled:hover {
  cursor: pointer;
  ::v-deep {
    input {
      text-decoration: underline;
    }
  }
}
.data-input-hyperlink-enabled {
  ::v-deep {
    input {
      color: map-get($colors, 'link') !important;
    }
  }
}
</style>
